import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CloseOutlined } from "@ant-design/icons";
import LS_SERVICE from "../../utils/localStorage";
import { getMenuIcon } from "../../constants/constent";

function PinnedMenu() {
  const navigate = useNavigate();

  const [pinnedMenu, setPinnedMenu] = useState(LS_SERVICE.getPinnedMenu());

  useEffect(() => {
    const updatePinned = (e) => {
      setPinnedMenu(e.detail);
    };

    window.addEventListener("pinnedMenuUpdated", updatePinned);

    return () => {
      window.removeEventListener("pinnedMenuUpdated", updatePinned);
    };
  }, []);

  const removePin = (e, key) => {
    e.stopPropagation();

    const updated = pinnedMenu.filter((item) => item.key !== key);

    setPinnedMenu(updated);

    LS_SERVICE.setPinnedMenu(updated);

    window.dispatchEvent(
      new CustomEvent("pinnedMenuUpdated", {
        detail: updated,
      }),
    );
  };

  if (!pinnedMenu.length) {
    return null;
  }

  return (
    <div
      style={{
        background: "#fff",
        padding: "8px 20px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        overflowX: "auto",
        borderBottom: "1px solid #eee",
        scrollbarWidth: "none",
      }}
    >
      {pinnedMenu.map((item) => (
        <div
          key={item.key}
          onClick={() => navigate(item.to)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "6px 12px",
            background:
              "linear-gradient(120deg, var(--primary-color), var(--secondary-color))",
            color: "var(--white)",
            borderRadius: "6px",
            cursor: "pointer",
            whiteSpace: "nowrap",
          }}
        >
          {getMenuIcon(item.key)}

          <span>{item.label}</span>

          <CloseOutlined
            style={{
              color: "red",
              fontSize: "12px",
            }}
            onClick={(e) => removePin(e, item.key)}
          />
        </div>
      ))}
    </div>
  );
}

export default PinnedMenu;
